module.exports = __webpack_public_path__ + "img/Send-money-2.f59c323b.png";